import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import "./footer.scss"

const Footer = ({ siteTitle }) => (
  <footer>
    <div className="footerWrapper">
      <h2 className="footerTitle">{siteTitle}</h2>
      <div className="sitemap">
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about/">About Stop Toxic Housing</Link></li>
          <li>
            <Link to="/site/">The US Navy Toxic Waste Site</Link>
          </li>
          <li><Link to="/proposal/">Freeway Air Toxins</Link></li>
        </ul>
      </div>
      <div className="rightAligned attribution">
        <div className="attributionText">
          © {new Date().getFullYear()}, Built by <a href="https://schimizzi.io">Marcus Schimizzi</a>
        </div>
      </div>
    </div>
  </footer>
)

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer
